import { useEffect, useState } from 'react';

/** Milliseconds since `since`, re-rendering once a second while it is set. */
export default function useElapsed(since) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (!since) {
            return undefined;
        }

        setNow(Date.now());
        const timer = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(timer);
    }, [since]);

    return since ? Math.max(0, now - since) : 0;
}
